import { render, staticRenderFns } from "./userLocation.vue?vue&type=template&id=3455d031&scoped=true&"
import script from "./userLocation.vue?vue&type=script&lang=js&"
export * from "./userLocation.vue?vue&type=script&lang=js&"
import style0 from "./userLocation.vue?vue&type=style&index=0&id=3455d031&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3455d031",
  null
  
)

export default component.exports